import {OnlineCertificatePage} from "../views/OnlineCertificate/OnlineCertificate";

const appRoutes = [
    // { path: "/ocert", name: "OnlineCertificate", icon: "pe-7s-monitor", component: OnlineCertificatePage },
    // { path: "/monitor", name: "Monitor", icon: "pe-7s-monitor", component: Monitor },
    // { redirect: true, path:"/", to:"/ocert", name: "Home" }
];

export default appRoutes;



// WEBPACK FOOTER //
// ./src/routes/app.jsx